// How the superadmin page shows a user's fields, shared by the users table and the user view.

// A status as shown: its first letter capitalized.
export const get_status_label = (status)=>{
	if(!status){
		return '';
	}

	return status.charAt(0).toUpperCase() + status.slice(1);
};

// A user's name, or their email when they have given none.
export const get_user_name = (user)=>{
	const name = [user.firstname, user.lastname].filter((part)=>{ return part; }).join(' ');
	return name ? name : user.email;
};

// A date as shown, in the browser's locale; '' for none.
export const format_date = (value)=>{
	if(!value){
		return '';
	}

	const date = new Date(value);
	if(isNaN(date.getTime())){
		return String(value);
	}

	return date.toLocaleString();
};
